module.exports = __webpack_public_path__ + "assets/img/memory_leak_document.8e7893c0.jpg";